import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  display: flex;
  flex-direction: column;
  .lock-status-container {
    position: fixed;
    z-index: 98;
    top: 64px;
    left: 0;
    right: 0;
    padding-top: 28px;
    padding-bottom: 24px;
    padding-right: 32px;
    padding-left: 32px;
    width: 100%;
    background-color: #f7f7f7;
  }
  & .container-table {
    width: 100%;
    padding: 0 32px;
  }
  & .ant-table-wrapper {
    margin-top: 70px;
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          padding-top: 18px;
          padding-bottom: 16px;
          padding-left: 16px;
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
          &:before {
            width: 0 !important;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          cursor: pointer;
          padding-top: 18px;
          padding-bottom: 16px;
          padding-left: 16px;
          &:first-child {
            padding-left: 48px;
          }
          &:last-child {
            padding-right: 48px;
          }
        }
      }
    }
  }
  .text-red {
    color: red;
  }
`;
